import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { SelectBuildProps } from 'components/molecules/SelectBuild/interfaces'
import { FormComplementaryKeys } from './types'

interface Schema {
    id: FormComplementaryKeys
}

export const FormComplementaryValue: {
    input?: InputBuildProps & Schema
    select?: SelectBuildProps & Schema
    layout: LayoutProps
}[] = [
        {
            select: {
                id: 'identificadorTaxaMora',
                label: 'Possui Taxa de mora?',
                optionsType: 'booleanType',
                defaultValue: 'NAO',
                placeholder: '-'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'valorTaxaMora',
                label: 'Taxa de mora',
                maskReplace: 'percentual',
                inputMode: 'numeric',
                maxLength: 12
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },

        {
            select: {
                id: 'identificadorTaxaMulta',
                label: 'Possui Taxa de multa?',
                optionsType: 'booleanType',
                defaultValue: 'NAO'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'valorTaxaMulta',
                label: 'Taxa de multa',
                maskReplace: 'percentual',
                inputMode: 'numeric',
                maxLength: 8,
                placeholder: '-'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'valorIOF',
                label: 'Valor de IOF',
                maskReplace: 'moeda',
                inputMode: 'numeric',
                maxLength: 15,
                placeholder: '-'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'valorTaxaJurosMes',
                label: 'Taxa de juros mês',
                maskReplace: 'percentual',
                inputMode: 'numeric',
                maxLength: 8,
                placeholder: '-'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'valorTaxaJurosAno',
                label: 'Taxa de juros ano',
                maskReplace: 'percentual',
                inputMode: 'numeric',
                maxLength: 8,
                placeholder: '-'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'valorTaxaContrato',
                label: 'Valor Taxa do Contrato',
                maskReplace: 'moeda',
                inputMode: 'numeric',
                maxLength: 15,
                placeholder: '-'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'indices',
                label: 'Índices'
            },
            layout: {
                type: 'col',
                layout: { base: 12 }
            }
        },
        {
            select: {
                id: 'identificadorComissao',
                label: 'Comissão?',
                optionsType: 'booleanType'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'valorComissao',
                label: 'Valor de comissão',
                maskReplace: 'moeda',
                inputMode: 'numeric',
                maxLength: 15
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            select: {
                id: 'indicacaoPenalidade',
                label: 'Existe penalidade?',
                optionsType: 'booleanType'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'penalidade',
                label: 'Penalidade',
                placeholder: '-'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'principalRecebedorPagamento',
                label: 'Principal recebedor do pagamento:'
            },
            layout: {
                type: 'col',
                layout: { base: 12 }
            }
        },
        {
            select: {
                id: 'tipoDocumentoRecebedor',
                label: 'Doc. recebedor',
                optionsType: 'doc'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'documentoPrincipalRecebedorPagamento',
                label: 'Nº do documento',
                maskReplace: 'registro'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            select: {
                id: 'tipoDocumentoVendedor',
                label: 'Doc. vendedor',
                optionsType: 'doc'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'documentoVendedor',
                label: 'Nº do documento',
                maskReplace: 'registro'
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 3 }
            }
        },
        {
            input: {
                id: 'comentarios',
                label: 'Comentários',
                placeholder: '-'
            },
            layout: {
                type: 'col',
                layout: { base: 12 }
            }
        },
        {
            input: {
                id: 'correcaoMonetaria',
                label: 'Correção Monetária',
                placeholder: '-'
            },
            layout: {
                type: 'col',
                layout: { base: 6 }
            }
        },
        {
            input: {
                id: 'numeroCertidaoNegativaDebitos',
                label: 'Nº Certidão Negativa de Débitos',
                maxLength: 60
            },
            layout: {
                type: 'col',
                layout: { base: 12, md: 6 }
            }
        } as const
    ]
